import {Home,Items,Assess,Countries,Zhuanti,Gongju,Feiyong,Ziliao,Duibi,Article,Vedio,Country,Countrycenter,Content,Contentcenter,Itemdetail,Itemdetailcenter,Jiangzuo,Search,
Result,Falv,Minizt,About,Jianmian} from '@/router/imports.js';
//如果要预渲染那么不能进行懒加载
// import Home from '@/components/home/Home.vue';//首页
// import Book from '@/components/book/Book.vue';
// import bookXijie from '@/components/book/Xijie.vue';//细节
// import bookGuige from '@/components/book/Guige.vue';//规格
// import Photo from '@/components/photo/Photo.vue';
// import photoXijie from '@/components/photo/Xijie.vue';//细节
// import photoGuige from '@/components/photo/Guige.vue';//规格
// import Acrossphoto from '@/components/acrossphoto/Acrossphoto.vue';
// import acrossphotoXijie from '@/components/acrossphoto/Xijie.vue';//细节
// import acrossphotoGuige from '@/components/acrossphoto/Guige.vue';//规格
// import Calendar from '@/components/calendar/Calendar.vue';
// import calendarXijie from '@/components/calendar/Xijie.vue';//细节
// import calendarGuige from '@/components/calendar/Guige.vue';//规格
// import Album from '@/components/album/Album.vue';
// import albumXijie from '@/components/album/Xijie.vue';//细节
// import albumGuige from '@/components/album/Guige.vue';//规格
// import Magazine from '@/components/magazine/Magazine.vue';
// import magazineXijie from '@/components/magazine/Xijie.vue';//细节
// import magazineGuige from '@/components/magazine/Guige.vue';//规格
// import About from '@/components/about/About.vue';//关于我们
// import Relation from '@/components/relation/Relation.vue';//联系我们
// import Duty from '@/components/duty/Duty.vue';//公益
// import Live from '@/components/live/Live.vue';//教程
// import liveList from '@/components/live/List.vue';//教程列表
// import liveContent from '@/components/live/Content.vue';//教程详情
// import Tweet from '@/components/tweet/Tweet.vue';//教程
// import tweetList from '@/components/tweet/List.vue';//教程列表
// import tweetContent from '@/components/tweet/Content.vue';//教程详情


// import Login from '@/components/login/Login.vue';//登录

// import appHead from '@/components/layout/Topbar.vue';
// import appLeft from '@/components/layout/Left.vue';
// import Centre from '@/components/centre/Centre.vue';
// import Format from '@/components/centre/Format.vue';//版式仓库
// import Makedesign from '@/components/centre/Makedesign.vue';//创建设计
// import Design from '@/components/centre/Design.vue';//我的设计 
// import Recycle from '@/components/centre/Recycle.vue';//回收站
// import Order from '@/components/centre/Order.vue';//我的订单
// import Coupons from '@/components/centre/Coupons.vue';//我的优惠券
// import Info from '@/components/centre/Info.vue';//个人信息
// import Service from '@/components/centre/Service.vue';//在线客服
// import Make from '@/components/make/Make.vue';//在线制作 - 主控板


// import Mobilemake from '@/components/mobile/mobilemake/Make.vue';//在线制作 - 主控板
// import Mobileinspect from '@/components/mobile/mobileinspect/Inspect.vue';//在线制作 - 检测页面
// import Mobilepay from '@/components/mobile/mobilepay/Pay.vue';//在线制作 - 支付页面
// import Mobilediscount from '@/components/mobile/mobilediscount/Discount.vue';//个人中心 - 我的优惠券
// import Mobileorder from '@/components/mobile/mobileorder/Order.vue';//个人中心 - 我的订单
// import Mobiledesign from '@/components/mobile/mobiledesign/Design.vue';//个人中心 - 我的订单
// import Mobiledesignbatch from '@/components/mobile/mobiledesignbatch/Design.vue';//个人中心 - 我的订单 批量管理
// import Mobilecontent from '@/components/live/Onlycontent.vue';//手机端文章详情


// import Sort from '@/components/make/Sort.vue';//在线制作 - 排序
// import Edit from '@/components/make/Edit.vue';//在线制作 - 操作面板
// e53fc42972c9b3ac996fc81000c0a401
// 17b2b8e1bf88a1c55551143766519f2a
export const routes = [
    // 首页
    { 
        path: '/', 
        name:'home',
        components:{
            default:Home
        }
    },
    // 移民项目
    { 
        path: '/items',
        name:'items',
        props:(route)=>{
            return {
                leixing_id:route.query.leixing_id
            }
        },
        component:Items
    },
    // 评估页面
    { 
        path: '/assess', 
        name:'assess',
        component:Assess
    },
    // 评估页面
    { 
        path: '/countries', 
        name:'countries',
        component:Countries
    },
    //关于我们
    { 
        path: '/about', 
        name:'about',
        components:{
            default:About
        }
    },
    //专题
    { 
        path: '/zhuanti', 
        name:'zhuanti',
        components:{
            default:Zhuanti
        }
    },
    //专题
    { 
        path: '/gongju', 
        name:'gongju',
        components:{
            default:Gongju
        }
    },
    //专题
    { 
        path: '/feiyong', 
        name:'feiyong',
        components:{
            default:Feiyong
        }
    },
    //专题
    { 
        path: '/ziliao', 
        name:'ziliao',
        components:{
            default:Ziliao
        }
    },
    //专题
    { 
        path: '/duibi', 
        name:'duibi',
        components:{
            default:Duibi
        }
    },
    { 
        path: '/article', 
        name:'article',
        components:{
            default:Article
        }
    },
    { 
        path: '/vedio', 
        name:'vedio',
        components:{
            default:Vedio
        }
    },
    { 
        path: '/country', 
        name:'country',
        children:[
            {
                path:'/country/:id',
                props:(route)=>{
                    return {
                        id:route.params.id
                    }
                },
                component:Countrycenter
            }
        ],
        redirect:'/',
        component:Country
    },
    { 
        path: '/content', 
        name:'content',
        children:[
            {
                path:'/content/:id',
                props:(route)=>{
                    return {
                        id:route.params.id
                    }
                },
                component:Contentcenter
            }
        ],
        redirect:'/',
        component:Content
    },
    { 
        path: '/itemdetail', 
        name:'itemdetail',
        children:[
            {
                path:'/itemdetail/:id',
                props:(route)=>{
                    return {
                        id:route.params.id
                    }
                },
                component:Itemdetailcenter
            }
        ],
        redirect:'/',
        component:Itemdetail
    },
    { 
        path: '/jiangzuo', 
        name:'jiangzuo',
        components:{
            default:Jiangzuo
        }
    },
    { 
        path: '/search', 
        name:'search',
        props:(route)=>{
            return {
                name:route.query.name
            }
        },
        component:Search
    },
    { 
        path: '/result', 
        name:'result',
        props:(route)=>{
            return {
                name:route.query.name
            }
        },
        component:Result
    },
    { 
        path: '/jianmian', 
        name:'jianmian',
        component:Jianmian
    },
    { 
        path: '/falv', 
        name:'falv',
        component:Falv
    },
    { 
        path: '/minizt', 
        name:'minizt',
        props:(route)=>{
            return {
                id:route.query.id,
                userid:route.query.userid
            }
        },
        component:Minizt
    },
    {
    	path:'*',
    	redirect:'/'
    }
];


// WEBPACK FOOTER //
// ./src/router/routes.js